import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { FrkBreakpoint, ResponsiveService } from '@frk/eds-components';
import { Observable, Subject } from 'rxjs';
import { InvestmentTeam } from '@products/models/investment-team';
import { takeUntil } from 'rxjs/operators';

export type ProfileLabel = {};

@Component({
  selector: 'ft-manager-profile',
  templateUrl: './manager-profile.component.html',
  styleUrls: ['./manager-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManagerProfileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() investmentTeam: InvestmentTeam;
  @Input() summaryLabel?: string;
  @Input() designationsLabel?: string;
  @Input() timeInIndustryLabel?: string;
  @Input() teamOrSimLabel: string;
  @Input() timeInFundLabel?: string;
  @Input() locationLabel?: string;
  isHandheld$: Observable<boolean>;
  showInvestmentTeamPanel: boolean;
  isStandardOrLargeDesktop: boolean;
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private meta: Meta,
    private title: Title,
    private responsiveService: ResponsiveService,
    private sanitizer: DomSanitizer
  ) {
    this.isHandheld$ = this.responsiveService.isHandheld$();
    this.responsiveService
      .getBreakpointObs$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((bp: FrkBreakpoint) => {
        this.isStandardOrLargeDesktop = [
          FrkBreakpoint.LargeDesktop,
          FrkBreakpoint.Desktop,
        ].includes(bp);
      });
  }

  /**
   * On init hook
   */
  ngOnInit() {}

  ngOnChanges() {
    // showInvestmentTeamPanel only if any of the data exists
    this.showInvestmentTeamPanel =
      !!this.investmentTeam?.profile?.designations ||
      !!this.investmentTeam?.yearsInIndustry ||
      !!this.investmentTeam?.profile?.teamOrSim ||
      !!this.investmentTeam?.profile?.timeInfund ||
      !!this.investmentTeam?.managerCity;
  }

  getSafeHTML(value: {}) {
    const json = value
      ? JSON.stringify(value, null, 2).replace(/\//g, '\\/')
      : '';
    const html = `<script type="application/ld+json">${json}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
